/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';
import type { DatasetPipelineShallow } from './DatasetPipelineShallow';
import {
  DatasetPipelineShallowFromJSON,
  DatasetPipelineShallowFromJSONTyped,
  DatasetPipelineShallowToJSON,
} from './DatasetPipelineShallow';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface AiModel
 */
export interface AiModel {
  /**
   *
   * @type {number}
   * @memberof AiModel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AiModel
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AiModel
   */
  technicalOwner: string;
  /**
   *
   * @type {string}
   * @memberof AiModel
   */
  technicalInfo: string;
  /**
   *
   * @type {string}
   * @memberof AiModel
   */
  datasetInfo: string;
  /**
   *
   * @type {UseCaseName}
   * @memberof AiModel
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof AiModel
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof AiModel
   */
  liveFrom?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof AiModel
   */
  decomissionedOn?: Date | null;
  /**
   *
   * @type {string}
   * @memberof AiModel
   */
  updateUser?: string;
  /**
   *
   * @type {Date}
   * @memberof AiModel
   */
  timestamp?: Date;
  /**
   *
   * @type {Date}
   * @memberof AiModel
   */
  lastValidation: Date;
  /**
   *
   * @type {Array<DatasetPipelineShallow>}
   * @memberof AiModel
   */
  readonly datasetPipelines: Array<DatasetPipelineShallow>;
}

/**
 * Check if a given object implements the AiModel interface.
 */
export function instanceOfAiModel(value: object): value is AiModel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('technicalOwner' in value) || value['technicalOwner'] === undefined) return false;
  if (!('technicalInfo' in value) || value['technicalInfo'] === undefined) return false;
  if (!('datasetInfo' in value) || value['datasetInfo'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('lastValidation' in value) || value['lastValidation'] === undefined) return false;
  if (!('datasetPipelines' in value) || value['datasetPipelines'] === undefined) return false;
  return true;
}

export function AiModelFromJSON(json: any): AiModel {
  return AiModelFromJSONTyped(json, false);
}

export function AiModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    technicalOwner: json['technical_owner'],
    technicalInfo: json['technical_info'],
    datasetInfo: json['dataset_info'],
    useCase: UseCaseNameFromJSON(json['use_case']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    liveFrom: json['live_from'] == null ? undefined : new Date(json['live_from']),
    decomissionedOn: json['decomissioned_on'] == null ? undefined : new Date(json['decomissioned_on']),
    updateUser: json['update_user'] == null ? undefined : json['update_user'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    lastValidation: new Date(json['last_validation']),
    datasetPipelines: (json['dataset_pipelines'] as Array<any>).map(DatasetPipelineShallowFromJSON),
  };
}

export function AiModelToJSON(value?: Omit<AiModel, 'id' | 'useCase' | 'datasetPipelines'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    technical_owner: value['technicalOwner'],
    technical_info: value['technicalInfo'],
    dataset_info: value['datasetInfo'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    live_from: value['liveFrom'] == null ? undefined : (value['liveFrom'] as any).toISOString().substring(0, 10),
    decomissioned_on:
      value['decomissionedOn'] == null ? undefined : (value['decomissionedOn'] as any).toISOString().substring(0, 10),
    update_user: value['updateUser'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    last_validation: value['lastValidation'].toISOString().substring(0, 10),
  };
}
